import { styled } from "@mui/material/styles";

export const Wrapper = styled("div")(({ theme }) => ({
    display: "grid",
    gridTemplateAreas: '"title price"',
    gridTemplateColumns: "auto min-content",
    gap: theme.spacing(2, 1),
}));

export const TitleWrapper = styled("div")({
    gridArea: "title",
    alignSelf: "start",
});
